import { render, staticRenderFns } from "./RenderUserChat.vue?vue&type=template&id=5a49dc1a&scoped=true"
import script from "./RenderUserChat.vue?vue&type=script&lang=js"
export * from "./RenderUserChat.vue?vue&type=script&lang=js"
import style0 from "./RenderUserChat.vue?vue&type=style&index=0&id=5a49dc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49dc1a",
  null
  
)

export default component.exports